module.exports = __webpack_public_path__ + "static/media/npm.3e4e2878.svg";